import { useState } from 'react';

// Real photos provided by Fundación Frais
const wastePhotos = [
  {
    src: 'https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/43531b34-589a-41cc-980c-c5835861c03f_WhatsApp-Image-2026-04-19-at-12.03.37.jpeg?v=211403d2cd5da65626b4397f1a1093e2',
    title: 'Muebles abandonados en zona verde',
    caption: 'Sofás y colchones arrojados en una zona boscosa de Santander. La naturaleza sufre en silencio.',
    tag: 'Residuos voluminosos',
    tagColor: '#c62828',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/5e5d786c-276e-4fdf-9276-f4a83d15758b_WhatsApp-Image-2026-04-19-at-12.03.39.jpeg?v=546e1ecbce34674b87e44855f6a164fe',
    title: 'Sofá en espacio público',
    caption: 'Un sofá abandonado en plena calle de Santander. Cada pieza tarda décadas en descomponerse.',
    tag: 'Contaminación urbana',
    tagColor: '#e65100',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/c0d5e16a-caaa-43ca-9788-2669876b9ca3_WhatsApp-Image-2026-04-19-at-12.03.40.jpeg?v=870f0375775ede75a26e9d77694cefec',
    title: 'Llantas en zona natural',
    caption: 'Una llanta abandonada junto al río. Libera toxinas que contaminan el agua que bebemos.',
    tag: 'Neumáticos',
    tagColor: '#4e342e',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/4f7c4b62-f432-4ecc-8abc-02528a49f20d_WhatsApp-Image-2026-04-19-at-12.03.49.jpeg?v=c089b98f7421ffff07fa2dbc8d48fea2',
    title: 'Basura acumulada en andén',
    caption: 'El letrero dice "No arrojar basura". La realidad habla más duro que las palabras.',
    tag: 'Desacato ambiental',
    tagColor: '#b71c1c',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/0b87572f-7f8f-467b-ba4f-35099c99dd1a_WhatsApp-Image-2026-04-19-at-12.03.53.jpeg?v=e7dccea8c4ac43142940d1919f7934e0',
    title: 'Colchones y residuos entre bambú',
    caption: 'Colchones y desechos mezclados con bambú nativo. Lo que era naturaleza, hoy es basurero.',
    tag: 'Destrucción ecológica',
    tagColor: '#37474f',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/5db277f2-f0e0-44b3-8da0-2a5648c0c8b1_WhatsApp-Image-2026-04-19-at-12.04.00.jpeg?v=03d797d887b63d9d51b5d0d5df8ed91d',
    title: 'Residuos en espacio público',
    caption: 'Llantas colgadas, basura en el separador vial. Los niños crecen viendo esto como normal.',
    tag: 'Impacto en comunidad',
    tagColor: '#6a1b9a',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/0754966e-ca48-4a79-bc2d-b66522853d1a_WhatsApp-Image-2026-04-19-at-12.04.02.jpeg?v=973e874e32405338012e8b5617fe1cd3',
    title: 'Vertedero improvisado',
    caption: 'Madera, plástico, vegetación y escombros mezclados. Un ecosistema destruido por negligencia.',
    tag: 'Zona crítica',
    tagColor: '#1b5e20',
  },
];

export default function GallerySection() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  return (
    <section className="w-full bg-[#0d0d0d] py-24 px-6 md:px-14">
      {/* Header */}
      <div className="max-w-5xl mx-auto text-center mb-16">
        <span
          className="inline-block text-[#ef9a9a] text-[10px] tracking-[0.5em] uppercase font-semibold mb-4"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Realidad documentada
        </span>
        <h2
          className="text-white font-bold leading-tight mb-5"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(2rem, 4vw, 3.4rem)',
          }}
        >
          Esto es lo que encontramos<br />
          <span style={{ color: '#ef9a9a' }}>en nuestros municipios.</span>
        </h2>
        <p
          className="text-white/50 text-sm leading-relaxed max-w-2xl mx-auto"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Estas no son fotos de archivo. Son imágenes reales tomadas por nuestro equipo en municipios de Santander. 
          Mientras lees esto, hay más. <strong className="text-white/75">¿Hasta cuándo?</strong>
        </p>
      </div>

      {/* Masonry-style grid with real photos */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {wastePhotos.map((photo, idx) => (
          <div
            key={idx}
            className={`relative group overflow-hidden rounded-xl cursor-pointer ${
              idx === 0 || idx === 3 ? 'sm:col-span-2 lg:col-span-1' : ''
            } ${idx === 6 ? 'sm:col-span-2' : ''}`}
            onClick={() => setLightbox(idx)}
            style={{ animation: `fadeInPhoto 0.6s ease ${idx * 0.08}s both` }}
          >
            <div className="relative overflow-hidden" style={{ height: idx === 0 || idx === 3 || idx === 6 ? '340px' : '280px' }}>
              <img
                src={photo.src}
                alt={photo.title}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
              />
              {/* Dark overlay — always visible, stronger on hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/10 group-hover:from-black/90 group-hover:via-black/40 transition-all duration-300"></div>

              {/* Tag */}
              <div className="absolute top-4 left-4">
                <span
                  className="inline-flex items-center gap-1.5 text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1.5 rounded-full"
                  style={{ backgroundColor: photo.tagColor + 'dd', fontFamily: "'Montserrat', sans-serif" }}
                >
                  <i className="ri-alert-line"></i>
                  {photo.tag}
                </span>
              </div>

              {/* Bottom text */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3
                  className="text-white font-bold text-sm mb-1.5 leading-snug"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {photo.title}
                </h3>
                <p
                  className="text-white/60 text-xs leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {photo.caption}
                </p>
              </div>

              {/* Zoom icon */}
              <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-white text-sm"></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Impact statement below gallery */}
      <div className="max-w-4xl mx-auto mt-14 text-center">
        <div className="flex items-center justify-center gap-6 flex-wrap">
          <div className="flex items-center gap-2 text-[#ef9a9a]">
            <i className="ri-map-pin-line text-base"></i>
            <span className="text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Fotografías reales en Santander
            </span>
          </div>
          <div className="w-px h-4 bg-white/20 hidden sm:block"></div>
          <div className="flex items-center gap-2 text-white/50">
            <i className="ri-calendar-line text-base"></i>
            <span className="text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Documentadas desde 2022
            </span>
          </div>
          <div className="w-px h-4 bg-white/20 hidden sm:block"></div>
          <div className="flex items-center gap-2 text-[#a5d6a7]">
            <i className="ri-recycle-line text-base"></i>
            <span className="text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Intervenidas por Fundación Frais
            </span>
          </div>
        </div>

        <p
          className="text-white/30 text-xs mt-6 italic leading-relaxed"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          "Cada imagen es una denuncia. Cada acción de la fundación, una respuesta."
        </p>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 md:p-10"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center cursor-pointer hover:bg-white/20 transition-colors"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line text-white text-xl"></i>
          </button>
          <div className="max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={wastePhotos[lightbox].src}
              alt={wastePhotos[lightbox].title}
              className="w-full max-h-[70vh] object-contain rounded-lg"
            />
            <div className="mt-4 text-center">
              <h3
                className="text-white font-bold text-lg mb-1"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {wastePhotos[lightbox].title}
              </h3>
              <p
                className="text-white/50 text-sm"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {wastePhotos[lightbox].caption}
              </p>
            </div>
          </div>
          {/* Nav arrows */}
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center cursor-pointer hover:bg-white/20 transition-colors"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + wastePhotos.length) % wastePhotos.length); }}
          >
            <i className="ri-arrow-left-line text-white"></i>
          </button>
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center cursor-pointer hover:bg-white/20 transition-colors"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % wastePhotos.length); }}
          >
            <i className="ri-arrow-right-line text-white"></i>
          </button>
        </div>
      )}

      <style>{`
        @keyframes fadeInPhoto {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
